import React, { useState } from 'react';

// ============================================
// ICON COMPONENTS
// ============================================
const Icon = ({ name, size = 24, color = 'currentColor' }) => {
  const icons = {
    // Agents
    plane: (
      <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" fill={color} />
    ),
    warning: (
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill={color} />
    ),
    star: (
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill={color} />
    ),
    takeoff: (
      <path d="M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49c.53.92 1.6 1.31 2.59 1.04L22 12.17c.81-.22 1.28-1.05 1.07-1.53z" fill={color} />
    ),
    dollar: (
      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill={color} />
    ),
    headset: (
      <path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z" fill={color} />
    ),
    // Channels
    mic: (
      <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" fill={color} />
    ),
    mobile: (
      <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" fill={color} />
    ),
    globe: (
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill={color} />
    ),
    chat: (
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" fill={color} />
    ),
    desktop: (
      <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z" fill={color} />
    ),
    kiosk: (
      <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v2H5z" fill={color} />
    ),
    // Core Systems
    ticket: (
      <path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z" fill={color} />
    ),
    passport: (
      <path d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H6zm6 3c1.93 0 3.5 1.57 3.5 3.5S13.93 12 12 12s-3.5-1.57-3.5-3.5S10.07 5 12 5zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 14.82 9.64 14 12 14s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V18z" fill={color} />
    ),
    trophy: (
      <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" fill={color} />
    ),
    chart: (
      <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" fill={color} />
    ),
    pilot: (
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill={color} />
    ),
    box: (
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-2-9H7v2h10v-2zm-4 4H7v2h6v-2z" fill={color} />
    ),
    // Sidebar
    shield: (
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" fill={color} />
    ),
    analytics: (
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" fill={color} />
    ),
    database: (
      <path d="M12 3C7.58 3 4 4.79 4 7v10c0 2.21 3.59 4 8 4s8-1.79 8-4V7c0-2.21-3.58-4-8-4zm0 2c3.87 0 6 1.5 6 2s-2.13 2-6 2-6-1.5-6-2 2.13-2 6-2zM6 17v-2.42c1.23.85 3.37 1.42 6 1.42s4.77-.57 6-1.42V17c0 .5-2.13 2-6 2s-6-1.5-6-2zm0-5v-2.42c1.23.85 3.37 1.42 6 1.42s4.77-.57 6-1.42V12c0 .5-2.13 2-6 2s-6-1.5-6-2z" fill={color} />
    ),
    // Tabs
    layers: (
      <path d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z" fill={color} />
    ),
    robot: (
      <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z" fill={color} />
    ),
    sync: (
      <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" fill={color} />
    ),
    tools: (
      <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" fill={color} />
    ),
    cloud: (
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z" fill={color} />
    )
  };

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {icons[name] || icons.plane}
    </svg>
  );
};

// ============================================
// AERONYX LOGO COMPONENT (Architecture Page)
// ============================================
const AeronyxLogoArch = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="aeronyxMainArch" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#06b6d4" />
        <stop offset="100%" stopColor="#8b5cf6" />
      </linearGradient>
      <linearGradient id="aeronyxAccentArch" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#8b5cf6" />
        <stop offset="100%" stopColor="#ec4899" />
      </linearGradient>
    </defs>
    <path d="M6 26L42 10L38 18L22 24L14 38L6 26Z" fill="url(#aeronyxMainArch)" />
    <path d="M14 38L22 24L26 32L18 42L14 38Z" fill="url(#aeronyxAccentArch)" opacity="0.85" />
    <path d="M4 28L12 24" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
    <path d="M6 34L10 32" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
  </svg>
);

// ============================================
// GLOBAL STYLES
// ============================================
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&family=Space+Mono:wght@400;700&display=swap');

  button, input, select, textarea { font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }

  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  @keyframes glow {
    0%, 100% { box-shadow: 0 0 5px rgba(6, 182, 212, 0.5); }
    50% { box-shadow: 0 0 20px rgba(6, 182, 212, 0.8), 0 0 30px rgba(139, 92, 246, 0.4); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }
  .arch-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  .arch-card:hover {
    transform: translateY(-4px) !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4) !important;
    border-color: rgba(6, 182, 212, 0.3) !important;
  }
  .arch-tab {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  .arch-tab:hover {
    background: rgba(6, 182, 212, 0.2) !important;
    transform: translateY(-2px);
  }
  .arch-layer {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .arch-layer:hover {
    transform: scale(1.005);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
  .arch-sidebar:hover {
    transform: translateX(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }
`;

// Inline styles to avoid Tailwind dependency issues
const styles = {
  container: {
    minHeight: '100vh',
    background: '#030712',
    padding: '32px 24px',
    color: 'white',
    fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  maxWidth: {
    maxWidth: '1500px',
    margin: '0 auto'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingTop: '20px'
  },
  title: {
    fontSize: '42px',
    fontWeight: '700',
    background: 'linear-gradient(135deg, #06b6d4, #8b5cf6, #ec4899)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '12px',
    letterSpacing: '-1px'
  },
  subtitle: {
    color: '#94a3b8',
    fontSize: '18px',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: '1.6'
  },
  tabContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '40px',
    flexWrap: 'wrap',
    padding: '8px',
    background: 'rgba(15, 23, 42, 0.6)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    maxWidth: 'fit-content',
    margin: '0 auto 40px'
  },
  tab: {
    padding: '14px 24px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },
  tabActive: {
    background: 'linear-gradient(135deg, #06b6d4, #8b5cf6)',
    color: 'white',
    boxShadow: '0 8px 24px rgba(6, 182, 212, 0.35)'
  },
  tabInactive: {
    background: 'transparent',
    color: '#94a3b8'
  },
  layerBox: {
    marginBottom: '20px',
    padding: '24px',
    borderRadius: '20px',
    border: '1px solid',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    backdropFilter: 'blur(10px)'
  },
  layerLabel: {
    fontSize: '11px',
    fontFamily: 'monospace',
    marginBottom: '8px',
    letterSpacing: '2px',
    textTransform: 'uppercase'
  },
  layerTitle: {
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '16px',
    letterSpacing: '-0.5px'
  },
  grid: {
    display: 'grid',
    gap: '16px'
  },
  card: {
    background: 'rgba(15, 23, 42, 0.6)',
    borderRadius: '16px',
    padding: '20px 16px',
    textAlign: 'center',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    cursor: 'pointer'
  },
  cardIcon: {
    fontSize: '32px',
    marginBottom: '8px'
  },
  cardTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: 'white'
  },
  cardSubtitle: {
    fontSize: '11px',
    marginTop: '6px'
  },
  connector: {
    display: 'flex',
    justifyContent: 'center',
    margin: '12px 0'
  },
  connectorInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  connectorLine: {
    width: '3px',
    height: '32px',
    borderRadius: '2px'
  },
  connectorLabel: {
    fontSize: '12px',
    color: '#94a3b8',
    background: 'rgba(15, 23, 42, 0.8)',
    padding: '6px 16px',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    fontWeight: '500'
  },
  mainGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 340px',
    gap: '24px'
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  sidebarBox: {
    background: 'rgba(15, 23, 42, 0.6)',
    borderRadius: '20px',
    padding: '20px',
    backdropFilter: 'blur(10px)',
    border: '1px solid'
  },
  sidebarTitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px'
  },
  sidebarItem: {
    background: 'rgba(51, 65, 85, 0.5)',
    borderRadius: '4px',
    padding: '8px',
    marginBottom: '8px'
  },
  sidebarItemTitle: {
    fontWeight: '500',
    fontSize: '12px'
  },
  sidebarItemDesc: {
    color: '#94a3b8',
    fontSize: '11px',
    marginTop: '4px'
  },
  badge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    marginRight: '4px',
    marginBottom: '4px'
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  toolCard: {
    background: 'rgba(30, 41, 59, 0.6)',
    borderRadius: '4px',
    padding: '8px',
    marginBottom: '8px'
  },
  monoText: {
    fontFamily: 'monospace',
    fontSize: '11px'
  }
};

const AeronyxArchitecture = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedAgent, setSelectedAgent] = useState('booking');

  const agents = {
    // ==================== CORE CUSTOMER-FACING ====================
    booking: {
      name: "Booking Agent",
      icon: "plane",
      iconColor: "#22d3ee",
      category: "Core Customer-Facing",
      purpose: "End-to-end flight search, booking, and modification",
      capabilities: [
        "Natural language flight search with fuzzy date/location matching",
        "Multi-city and complex itinerary construction",
        "Real-time seat map visualization and selection",
        "Ancillary bundling (bags, meals, insurance)",
        "PNR creation with passenger details validation",
        "Fare comparison across cabin classes"
      ],
      mcpTools: [
        { name: "search_availability", params: "origin, dest, dates, pax, cabin", returns: "FlightOption[]" },
        { name: "get_fare_quote", params: "flights[], pax_types[]", returns: "FareBreakdown" },
        { name: "create_pnr", params: "itinerary, passengers, contact", returns: "PNR" },
        { name: "add_ancillary", params: "pnr, ancillary_type, segment", returns: "Confirmation" },
        { name: "get_seat_map", params: "flight, cabin", returns: "SeatMap" },
        { name: "assign_seat", params: "pnr, pax, seat", returns: "SeatAssignment" }
      ],
      integrations: ["PSS (Amadeus/Sabre)", "Payment Gateway", "Seat Inventory"],
      stateManagement: ["Search context", "Selected flights", "Passenger manifest"]
    },
    disruption: {
      name: "Disruption Agent",
      icon: "warning",
      iconColor: "#fbbf24",
      category: "Core Customer-Facing",
      purpose: "Proactive and reactive handling of flight irregularities",
      capabilities: [
        "Real-time delay/cancellation detection",
        "Automated rebooking with preference learning",
        "EU261/DOT compensation calculation",
        "Alternative routing with connection protection",
        "Hotel and meal voucher issuance"
      ],
      mcpTools: [
        { name: "get_flight_status", params: "flight_number, date", returns: "FlightStatus" },
        { name: "find_alternatives", params: "original_seg, constraints", returns: "Alternative[]" },
        { name: "rebook_passenger", params: "pnr, new_itinerary", returns: "ReBookingConf" },
        { name: "calculate_compensation", params: "disruption, route", returns: "Compensation" },
        { name: "issue_voucher", params: "pnr, voucher_type, amount", returns: "Voucher" }
      ],
      integrations: ["OCC", "Hotel Inventory", "Ground Transport"],
      stateManagement: ["Disruption context", "Rebooking attempts", "Compensation status"]
    },
    loyalty: {
      name: "Loyalty Agent",
      icon: "star",
      iconColor: "#a78bfa",
      category: "Core Customer-Facing",
      purpose: "Frequent flyer program management and engagement",
      capabilities: [
        "Points balance and expiry tracking",
        "Award flight search and redemption",
        "Status tier benefits explanation",
        "Upgrade request management",
        "Partner earning and burning"
      ],
      mcpTools: [
        { name: "get_member_profile", params: "ffn or email", returns: "MemberProfile" },
        { name: "get_balance", params: "member_id", returns: "PointsBalance" },
        { name: "search_awards", params: "origin, dest, dates", returns: "AwardOption[]" },
        { name: "redeem_award", params: "member_id, award_id", returns: "Redemption" },
        { name: "request_upgrade", params: "pnr, member_id, segment", returns: "UpgradeStatus" }
      ],
      integrations: ["FFP Platform", "Partner Networks", "Tier Engine"],
      stateManagement: ["Member context", "Transaction history"]
    },
    support: {
      name: "Support Agent",
      icon: "headset",
      iconColor: "#60a5fa",
      category: "Core Customer-Facing",
      purpose: "Customer service and issue resolution",
      capabilities: [
        "Intelligent FAQ handling",
        "Complaint intake and tracking",
        "Policy explanations",
        "Feedback collection",
        "Human escalation management"
      ],
      mcpTools: [
        { name: "search_knowledge", params: "query, category", returns: "Article[]" },
        { name: "create_case", params: "pnr, category, description", returns: "CaseNumber" },
        { name: "get_case_status", params: "case_id", returns: "CaseStatus" },
        { name: "escalate_to_agent", params: "case_id, context", returns: "EscalationConf" },
        { name: "submit_feedback", params: "pnr, rating, comments", returns: "FeedbackId" }
      ],
      integrations: ["CRM", "Knowledge Base", "Case Management"],
      stateManagement: ["Case context", "Interaction history"]
    },
    baggage: {
      name: "Baggage Agent",
      icon: "box",
      iconColor: "#f472b6",
      category: "Core Customer-Facing",
      purpose: "Luggage management and tracking",
      capabilities: [
        "Real-time baggage tracking",
        "Delayed baggage claim filing",
        "Damage report submission",
        "Lost item recovery coordination",
        "Baggage allowance queries"
      ],
      mcpTools: [
        { name: "track_baggage", params: "tag_number", returns: "BaggageStatus" },
        { name: "file_delay_claim", params: "pnr, tag_number, description", returns: "ClaimNumber" },
        { name: "report_damage", params: "pnr, tag_number, damage_type", returns: "DamageReport" },
        { name: "get_allowance", params: "route, cabin, ffn_tier", returns: "BaggageAllowance" },
        { name: "request_delivery", params: "claim_id, address", returns: "DeliveryETA" }
      ],
      integrations: ["WorldTracer", "BRS", "Delivery Partners"],
      stateManagement: ["Claim context", "Tracking updates"]
    },
    checkin: {
      name: "Check-in Agent",
      icon: "passport",
      iconColor: "#4ade80",
      category: "Core Customer-Facing",
      purpose: "Pre-departure services and document verification",
      capabilities: [
        "Online check-in processing",
        "Travel document verification",
        "Seat change requests",
        "Boarding pass delivery",
        "APIS data collection"
      ],
      mcpTools: [
        { name: "initiate_checkin", params: "pnr, passenger_id", returns: "CheckinSession" },
        { name: "verify_documents", params: "pnr, doc_type, doc_number", returns: "VerificationResult" },
        { name: "change_seat", params: "pnr, passenger, new_seat", returns: "SeatConfirmation" },
        { name: "generate_boarding_pass", params: "pnr, passenger, format", returns: "BoardingPass" },
        { name: "submit_apis", params: "pnr, passenger, travel_docs", returns: "APISConfirmation" }
      ],
      integrations: ["DCS", "TIMATIC", "Document Verification"],
      stateManagement: ["Check-in session", "Document status"]
    },
    // ==================== REVENUE & COMMERCIAL ====================
    revenue: {
      name: "Revenue Agent",
      icon: "dollar",
      iconColor: "#fcd34d",
      category: "Revenue & Commercial",
      purpose: "Pricing, upselling, and revenue optimization",
      capabilities: [
        "Dynamic fare explanation",
        "Upsell recommendations",
        "Refund calculations",
        "Promotional code validation",
        "Fare rule interpretation"
      ],
      mcpTools: [
        { name: "get_fare_rules", params: "fare_basis", returns: "FareRules" },
        { name: "calculate_refund", params: "pnr, segments", returns: "RefundAmount" },
        { name: "apply_promo", params: "booking, promo_code", returns: "DiscountResult" },
        { name: "get_upsell_offers", params: "pnr, context", returns: "UpsellOffer[]" },
        { name: "explain_pricing", params: "fare_breakdown", returns: "PriceExplanation" }
      ],
      integrations: ["RMS", "Fare Filing", "Promo Engine"],
      stateManagement: ["Pricing context", "Applied discounts"]
    },
    ancillary: {
      name: "Ancillary Sales Agent",
      icon: "box",
      iconColor: "#fb923c",
      category: "Revenue & Commercial",
      purpose: "Add-on revenue and service sales",
      capabilities: [
        "Baggage purchase recommendations",
        "Seat upgrade offers",
        "Meal pre-ordering",
        "Lounge access sales",
        "Travel insurance bundling"
      ],
      mcpTools: [
        { name: "get_ancillary_catalog", params: "route, cabin, pax_type", returns: "AncillaryCatalog" },
        { name: "add_baggage", params: "pnr, segment, weight", returns: "BaggageConfirmation" },
        { name: "purchase_seat", params: "pnr, seat_type, segment", returns: "SeatPurchase" },
        { name: "order_meal", params: "pnr, segment, meal_code", returns: "MealOrder" },
        { name: "bundle_services", params: "pnr, services[]", returns: "BundlePrice" }
      ],
      integrations: ["Ancillary Engine", "Payment Gateway", "Catering System"],
      stateManagement: ["Cart contents", "Applied bundles"]
    },
    corporate: {
      name: "Corporate Travel Agent",
      icon: "desktop",
      iconColor: "#a3e635",
      category: "Revenue & Commercial",
      purpose: "B2B account management and corporate bookings",
      capabilities: [
        "Corporate rate access",
        "Travel policy compliance checking",
        "Consolidated reporting",
        "TMC integration support",
        "Bulk booking management"
      ],
      mcpTools: [
        { name: "get_corporate_rates", params: "company_id, route", returns: "CorporateFares" },
        { name: "check_policy", params: "company_id, itinerary", returns: "PolicyCompliance" },
        { name: "create_corporate_booking", params: "company_id, travelers, itinerary", returns: "CorporatePNR" },
        { name: "generate_report", params: "company_id, date_range, report_type", returns: "TravelReport" },
        { name: "sync_tmc", params: "booking, tmc_id", returns: "SyncStatus" }
      ],
      integrations: ["Corporate Portal", "TMC Systems", "Expense Management"],
      stateManagement: ["Company context", "Policy rules"]
    },
    cargo: {
      name: "Cargo Agent",
      icon: "box",
      iconColor: "#38bdf8",
      category: "Revenue & Commercial",
      purpose: "Freight handling and cargo operations",
      capabilities: [
        "Cargo booking and quotes",
        "Shipment tracking",
        "Customs documentation",
        "Rate calculations",
        "Capacity queries"
      ],
      mcpTools: [
        { name: "get_cargo_quote", params: "origin, dest, weight, dimensions", returns: "CargoQuote" },
        { name: "book_cargo", params: "quote_id, shipper, consignee", returns: "AWB" },
        { name: "track_shipment", params: "awb_number", returns: "ShipmentStatus" },
        { name: "generate_customs_docs", params: "awb, doc_type", returns: "CustomsDocument" },
        { name: "check_capacity", params: "flight, cargo_type", returns: "CargoCapacity" }
      ],
      integrations: ["Cargo Management System", "Customs", "Ground Handlers"],
      stateManagement: ["Shipment context", "Documentation status"]
    },
    // ==================== OPERATIONS ====================
    flightstatus: {
      name: "Flight Status Agent",
      icon: "takeoff",
      iconColor: "#34d399",
      category: "Operations",
      purpose: "Real-time flight information and updates",
      capabilities: [
        "Departure and arrival times",
        "Gate information updates",
        "Delay notifications",
        "Connection monitoring",
        "Weather impact assessment"
      ],
      mcpTools: [
        { name: "get_flight_info", params: "flight, date", returns: "FlightDetails" },
        { name: "get_gate_info", params: "flight, airport", returns: "GateAssignment" },
        { name: "subscribe_updates", params: "flight, notification_type", returns: "SubscriptionId" },
        { name: "check_connections", params: "pnr, min_connect_time", returns: "ConnectionStatus" },
        { name: "get_weather_impact", params: "airport, time_range", returns: "WeatherImpact" }
      ],
      integrations: ["OCC", "AODB", "Weather Services"],
      stateManagement: ["Flight watch list", "Alert subscriptions"]
    },
    crew: {
      name: "Crew Agent",
      icon: "pilot",
      iconColor: "#2dd4bf",
      category: "Operations",
      purpose: "Crew management and roster coordination",
      capabilities: [
        "Roster queries and viewing",
        "Swap request processing",
        "Duty time calculations",
        "Standby management",
        "Fatigue risk assessment"
      ],
      mcpTools: [
        { name: "get_roster", params: "crew_id, date_range", returns: "CrewRoster" },
        { name: "request_swap", params: "crew_id, duty_id, swap_with", returns: "SwapRequest" },
        { name: "calculate_duty_time", params: "crew_id, date", returns: "DutyTimeSummary" },
        { name: "check_standby", params: "base, qualification", returns: "StandbyList" },
        { name: "assess_fatigue", params: "crew_id, proposed_duty", returns: "FatigueScore" }
      ],
      integrations: ["Crew Management System", "FRMS", "Payroll"],
      stateManagement: ["Crew context", "Request history"]
    },
    groundops: {
      name: "Ground Ops Agent",
      icon: "tools",
      iconColor: "#22d3ee",
      category: "Operations",
      purpose: "Airport operations and turnaround coordination",
      capabilities: [
        "Turnaround progress tracking",
        "Catering coordination",
        "Fueling status updates",
        "Cleaning verification",
        "Push-back scheduling"
      ],
      mcpTools: [
        { name: "get_turnaround_status", params: "flight", returns: "TurnaroundProgress" },
        { name: "update_catering", params: "flight, status", returns: "CateringUpdate" },
        { name: "request_fuel", params: "flight, fuel_quantity", returns: "FuelRequest" },
        { name: "confirm_cleaning", params: "flight, checklist", returns: "CleaningConfirmation" },
        { name: "schedule_pushback", params: "flight, requested_time", returns: "PushbackSlot" }
      ],
      integrations: ["Ground Handler Systems", "Fuel Provider", "Catering"],
      stateManagement: ["Turnaround context", "Service status"]
    },
    maintenance: {
      name: "Maintenance Agent",
      icon: "tools",
      iconColor: "#818cf8",
      category: "Operations",
      purpose: "Aircraft health and maintenance coordination",
      capabilities: [
        "MEL queries and tracking",
        "Defect reporting",
        "Parts availability checking",
        "Maintenance scheduling",
        "Airworthiness status"
      ],
      mcpTools: [
        { name: "get_mel_status", params: "registration", returns: "MELItems[]" },
        { name: "report_defect", params: "registration, defect_details", returns: "DefectReport" },
        { name: "check_parts", params: "part_number, location", returns: "PartsAvailability" },
        { name: "schedule_maintenance", params: "registration, task_type", returns: "MaintenanceSlot" },
        { name: "get_airworthiness", params: "registration", returns: "AirworthinessStatus" }
      ],
      integrations: ["MRO System", "Parts Inventory", "Tech Records"],
      stateManagement: ["Aircraft context", "Open items"]
    },
    loadplanning: {
      name: "Load Planning Agent",
      icon: "chart",
      iconColor: "#c084fc",
      category: "Operations",
      purpose: "Weight and balance optimization",
      capabilities: [
        "Passenger distribution planning",
        "Cargo loading optimization",
        "Fuel optimization calculations",
        "Trim calculations",
        "Load sheet generation"
      ],
      mcpTools: [
        { name: "calculate_balance", params: "flight, load_data", returns: "BalanceResult" },
        { name: "optimize_loading", params: "flight, cargo_manifest", returns: "LoadPlan" },
        { name: "calculate_fuel", params: "route, payload, conditions", returns: "FuelRequirement" },
        { name: "generate_loadsheet", params: "flight", returns: "LoadSheet" },
        { name: "check_limits", params: "flight, proposed_load", returns: "LimitCheck" }
      ],
      integrations: ["Weight & Balance System", "Fuel Planning", "DCS"],
      stateManagement: ["Flight load context", "Optimization parameters"]
    },
    // ==================== SPECIALIZED SERVICES ====================
    specialservices: {
      name: "Special Services Agent",
      icon: "headset",
      iconColor: "#e879f9",
      category: "Specialized Services",
      purpose: "Accessibility and special needs coordination",
      capabilities: [
        "Wheelchair request processing",
        "Medical clearance coordination",
        "Unaccompanied minor handling",
        "Pet travel arrangements",
        "Special dietary requirements"
      ],
      mcpTools: [
        { name: "request_wheelchair", params: "pnr, segment, service_type", returns: "WheelchairConfirmation" },
        { name: "submit_medif", params: "pnr, medical_info", returns: "MedicalClearance" },
        { name: "setup_umnr", params: "pnr, minor_details, guardians", returns: "UMNRService" },
        { name: "book_pet", params: "pnr, pet_details, container", returns: "PetBooking" },
        { name: "request_meal", params: "pnr, segment, meal_type", returns: "SpecialMealConfirmation" }
      ],
      integrations: ["SSR System", "Medical Desk", "Ground Services"],
      stateManagement: ["Service requests", "Special needs profile"]
    },
    visa: {
      name: "Visa & Travel Docs Agent",
      icon: "passport",
      iconColor: "#fb7185",
      category: "Specialized Services",
      purpose: "Entry requirements and document verification",
      capabilities: [
        "Visa requirements lookup",
        "Passport validity checking",
        "Health documentation requirements",
        "TIMATIC integration",
        "Transit visa guidance"
      ],
      mcpTools: [
        { name: "check_visa_requirements", params: "nationality, destination, purpose", returns: "VisaRequirements" },
        { name: "validate_passport", params: "passport_number, nationality, expiry", returns: "PassportValidity" },
        { name: "get_health_requirements", params: "origin, destination", returns: "HealthRequirements" },
        { name: "check_transit", params: "nationality, transit_country", returns: "TransitRequirements" },
        { name: "verify_travel_docs", params: "pnr, documents[]", returns: "DocumentVerification" }
      ],
      integrations: ["TIMATIC", "Embassy Systems", "Health Authorities"],
      stateManagement: ["Passenger nationality", "Destination requirements"]
    },
    lounge: {
      name: "Lounge Agent",
      icon: "star",
      iconColor: "#fbbf24",
      category: "Specialized Services",
      purpose: "Premium services and lounge access",
      capabilities: [
        "Access eligibility checking",
        "Lounge capacity monitoring",
        "Amenity information",
        "Guest pass booking",
        "Partner lounge network"
      ],
      mcpTools: [
        { name: "check_eligibility", params: "pnr, lounge_id", returns: "EligibilityResult" },
        { name: "get_capacity", params: "lounge_id, time", returns: "LoungeCapacity" },
        { name: "book_access", params: "pnr, lounge_id, guests", returns: "LoungeBooking" },
        { name: "find_partner_lounge", params: "airport, program", returns: "PartnerLounges[]" },
        { name: "purchase_pass", params: "pnr, lounge_id", returns: "PassPurchase" }
      ],
      integrations: ["Lounge Management", "Partner Networks", "Payment Gateway"],
      stateManagement: ["Eligibility context", "Booking status"]
    },
    rebooking: {
      name: "Rebooking Agent",
      icon: "sync",
      iconColor: "#38bdf8",
      category: "Specialized Services",
      purpose: "Schedule changes and voluntary rebooking",
      capabilities: [
        "Voluntary change processing",
        "Fare difference calculation",
        "Same-day standby management",
        "Flight flexibility options",
        "Waiver application"
      ],
      mcpTools: [
        { name: "find_alternatives", params: "pnr, preferences", returns: "AlternativeFlights[]" },
        { name: "calculate_fare_diff", params: "pnr, new_itinerary", returns: "FareDifference" },
        { name: "request_standby", params: "pnr, target_flight", returns: "StandbyRequest" },
        { name: "apply_waiver", params: "pnr, waiver_code", returns: "WaiverResult" },
        { name: "confirm_change", params: "pnr, new_itinerary, payment", returns: "ChangeConfirmation" }
      ],
      integrations: ["PSS", "Revenue Management", "Payment Gateway"],
      stateManagement: ["Change context", "Fare calculations"]
    },
    refund: {
      name: "Refund Agent",
      icon: "dollar",
      iconColor: "#4ade80",
      category: "Specialized Services",
      purpose: "Refund processing and voucher management",
      capabilities: [
        "Refund eligibility assessment",
        "Refund amount calculation",
        "Processing status tracking",
        "Voucher conversion options",
        "Tax refund handling"
      ],
      mcpTools: [
        { name: "check_refund_eligibility", params: "pnr, segments", returns: "RefundEligibility" },
        { name: "calculate_refund", params: "pnr, refund_type", returns: "RefundCalculation" },
        { name: "initiate_refund", params: "pnr, refund_method", returns: "RefundRequest" },
        { name: "get_refund_status", params: "refund_id", returns: "RefundStatus" },
        { name: "convert_to_voucher", params: "pnr, validity_period", returns: "VoucherDetails" }
      ],
      integrations: ["PSS", "Payment Gateway", "Accounting"],
      stateManagement: ["Refund context", "Processing status"]
    },
    group: {
      name: "Group Booking Agent",
      icon: "pilot",
      iconColor: "#a78bfa",
      category: "Specialized Services",
      purpose: "Group travel management (10+ passengers)",
      capabilities: [
        "Group quote generation",
        "Deposit management",
        "Name change processing",
        "Rooming list coordination",
        "Group payment tracking"
      ],
      mcpTools: [
        { name: "request_group_quote", params: "route, pax_count, travel_dates", returns: "GroupQuote" },
        { name: "create_group_booking", params: "quote_id, group_name, contact", returns: "GroupPNR" },
        { name: "add_names", params: "group_pnr, passengers[]", returns: "NameAddition" },
        { name: "process_deposit", params: "group_pnr, amount", returns: "DepositConfirmation" },
        { name: "manage_rooming", params: "group_pnr, room_assignments", returns: "RoomingList" }
      ],
      integrations: ["Group Desk", "Payment Gateway", "Hotel Partners"],
      stateManagement: ["Group context", "Payment schedule"]
    },
    // ==================== INTERNAL OPERATIONS ====================
    network: {
      name: "Network Planning Agent",
      icon: "globe",
      iconColor: "#f472b6",
      category: "Internal Operations",
      purpose: "Route optimization and schedule planning",
      capabilities: [
        "Demand forecasting",
        "Slot management",
        "Schedule optimization",
        "Codeshare coordination",
        "Route profitability analysis"
      ],
      mcpTools: [
        { name: "forecast_demand", params: "route, season", returns: "DemandForecast" },
        { name: "check_slots", params: "airport, time_range", returns: "SlotAvailability" },
        { name: "optimize_schedule", params: "constraints, objectives", returns: "OptimizedSchedule" },
        { name: "manage_codeshare", params: "partner, routes", returns: "CodeshareAgreement" },
        { name: "analyze_route", params: "route, period", returns: "RouteProfitability" }
      ],
      integrations: ["Schedule System", "Slot Coordinator", "Revenue Analytics"],
      stateManagement: ["Planning context", "Optimization parameters"]
    },
    safety: {
      name: "Safety & Compliance Agent",
      icon: "shield",
      iconColor: "#fb923c",
      category: "Internal Operations",
      purpose: "Regulatory adherence and safety management",
      capabilities: [
        "Incident reporting",
        "Audit preparation",
        "Regulatory update tracking",
        "Safety bulletin distribution",
        "Compliance monitoring"
      ],
      mcpTools: [
        { name: "submit_incident", params: "incident_type, details, flight", returns: "IncidentReport" },
        { name: "prepare_audit", params: "audit_type, scope", returns: "AuditPackage" },
        { name: "get_regulatory_updates", params: "authority, category", returns: "RegulatoryUpdates[]" },
        { name: "distribute_bulletin", params: "bulletin_type, recipients", returns: "DistributionStatus" },
        { name: "check_compliance", params: "area, requirements", returns: "ComplianceStatus" }
      ],
      integrations: ["SMS", "QMS", "Regulatory Databases"],
      stateManagement: ["Compliance status", "Open findings"]
    },
    training: {
      name: "Training Agent",
      icon: "robot",
      iconColor: "#60a5fa",
      category: "Internal Operations",
      purpose: "Staff development and certification management",
      capabilities: [
        "Course scheduling",
        "Certification tracking",
        "Recency requirement monitoring",
        "E-learning management",
        "Training record access"
      ],
      mcpTools: [
        { name: "schedule_training", params: "employee_id, course_id", returns: "TrainingBooking" },
        { name: "check_certifications", params: "employee_id", returns: "CertificationStatus[]" },
        { name: "get_recency", params: "employee_id, qualification", returns: "RecencyStatus" },
        { name: "assign_elearning", params: "employee_id, modules[]", returns: "ElearningAssignment" },
        { name: "get_training_record", params: "employee_id", returns: "TrainingHistory" }
      ],
      integrations: ["LMS", "HR System", "Qualification Database"],
      stateManagement: ["Training context", "Certification alerts"]
    },
    hr: {
      name: "HR Agent",
      icon: "pilot",
      iconColor: "#c084fc",
      category: "Internal Operations",
      purpose: "Employee services and HR support",
      capabilities: [
        "Leave request processing",
        "Benefits queries",
        "Policy information",
        "Onboarding support",
        "Payroll queries"
      ],
      mcpTools: [
        { name: "submit_leave", params: "employee_id, leave_type, dates", returns: "LeaveRequest" },
        { name: "get_benefits", params: "employee_id, benefit_type", returns: "BenefitsInfo" },
        { name: "search_policy", params: "policy_category, query", returns: "PolicyArticles[]" },
        { name: "get_onboarding_tasks", params: "employee_id", returns: "OnboardingChecklist" },
        { name: "query_payroll", params: "employee_id, period", returns: "PayrollDetails" }
      ],
      integrations: ["HRIS", "Payroll System", "Benefits Portal"],
      stateManagement: ["Employee context", "Request history"]
    },
    procurement: {
      name: "Procurement Agent",
      icon: "box",
      iconColor: "#2dd4bf",
      category: "Internal Operations",
      purpose: "Vendor management and purchasing",
      capabilities: [
        "Purchase order creation",
        "Contract queries",
        "Supplier performance tracking",
        "Invoice matching",
        "Budget monitoring"
      ],
      mcpTools: [
        { name: "create_po", params: "vendor_id, items[], budget_code", returns: "PurchaseOrder" },
        { name: "get_contract", params: "vendor_id, contract_type", returns: "ContractDetails" },
        { name: "check_supplier", params: "vendor_id", returns: "SupplierPerformance" },
        { name: "match_invoice", params: "invoice_id, po_number", returns: "MatchResult" },
        { name: "check_budget", params: "cost_center, period", returns: "BudgetStatus" }
      ],
      integrations: ["ERP", "Vendor Portal", "Finance System"],
      stateManagement: ["Procurement context", "Approval workflow"]
    }
  };

  // Comprehensive categorized agents for the full ecosystem view
  const allAgentsCategories = [
    {
      category: "Core Customer-Facing",
      description: "Primary agents handling direct passenger interactions",
      color: "#06b6d4",
      agents: [
        { id: "booking", name: "Booking Agent", icon: "plane", color: "#22d3ee", purpose: "End-to-end reservation management", functions: ["Flight search", "PNR creation", "Seat selection", "Ancillaries", "Modifications", "Group bookings"] },
        { id: "disruption", name: "Disruption Agent", icon: "warning", color: "#fbbf24", purpose: "Irregular operations handling", functions: ["Delay notifications", "Auto-rebooking", "EU261/DOT compensation", "Hotel/meal vouchers", "Alternative routing"] },
        { id: "loyalty", name: "Loyalty Agent", icon: "star", color: "#a78bfa", purpose: "Frequent flyer program", functions: ["Points balance", "Award redemption", "Tier benefits", "Upgrades", "Partner earning/burning"] },
        { id: "support", name: "Support Agent", icon: "headset", color: "#60a5fa", purpose: "General customer service", functions: ["FAQ handling", "Complaints", "Feedback", "Policy explanations", "Human escalation"] },
        { id: "baggage", name: "Baggage Agent", icon: "box", color: "#f472b6", purpose: "Luggage management", functions: ["Tracking", "Delayed baggage claims", "Damage reports", "Lost item recovery", "Allowance queries"] },
        { id: "checkin", name: "Check-in Agent", icon: "passport", color: "#4ade80", purpose: "Pre-departure services", functions: ["Online check-in", "Document verification", "Seat changes", "Boarding pass delivery"] }
      ]
    },
    {
      category: "Revenue & Commercial",
      description: "Agents focused on revenue generation and commercial operations",
      color: "#f59e0b",
      agents: [
        { id: "revenue", name: "Revenue Agent", icon: "dollar", color: "#fcd34d", purpose: "Pricing & monetization", functions: ["Dynamic pricing", "Upsell/cross-sell", "Refund processing", "Promo validation", "Fare rules"] },
        { id: "ancillary", name: "Ancillary Sales Agent", icon: "box", color: "#fb923c", purpose: "Add-on revenue", functions: ["Bags", "Seats", "Meals", "Lounge access", "Insurance", "WiFi", "Priority boarding"] },
        { id: "corporate", name: "Corporate Travel Agent", icon: "desktop", color: "#a3e635", purpose: "B2B account management", functions: ["Corporate booking", "Policy compliance", "Reporting", "TMC integration"] },
        { id: "cargo", name: "Cargo Agent", icon: "box", color: "#38bdf8", purpose: "Freight handling", functions: ["Cargo booking", "Tracking", "Customs documentation", "Rate quotes", "Capacity queries"] }
      ]
    },
    {
      category: "Operations",
      description: "Agents supporting flight and ground operations",
      color: "#10b981",
      agents: [
        { id: "flightstatus", name: "Flight Status Agent", icon: "takeoff", color: "#34d399", purpose: "Real-time information", functions: ["Departure/arrival times", "Gate info", "Delays", "Connections", "Weather impact"] },
        { id: "crew", name: "Crew Agent", icon: "pilot", color: "#2dd4bf", purpose: "Crew management", functions: ["Roster queries", "Swap requests", "Duty time calculations", "Standby management"] },
        { id: "groundops", name: "Ground Ops Agent", icon: "tools", color: "#22d3ee", purpose: "Airport operations", functions: ["Turnaround coordination", "Catering", "Fueling", "Cleaning", "Push-back scheduling"] },
        { id: "maintenance", name: "Maintenance Agent", icon: "tools", color: "#818cf8", purpose: "Aircraft health", functions: ["MEL queries", "Defect reporting", "Parts availability", "Maintenance scheduling"] },
        { id: "loadplanning", name: "Load Planning Agent", icon: "chart", color: "#c084fc", purpose: "Weight & balance", functions: ["Passenger distribution", "Cargo loading", "Fuel optimization", "Trim calculations"] }
      ]
    },
    {
      category: "Specialized Services",
      description: "Agents handling specific passenger needs and services",
      color: "#8b5cf6",
      agents: [
        { id: "specialservices", name: "Special Services Agent", icon: "headset", color: "#e879f9", purpose: "Accessibility & special needs", functions: ["Wheelchair requests", "Medical clearance", "Unaccompanied minors", "Pet travel", "Dietary needs"] },
        { id: "visa", name: "Visa & Travel Docs Agent", icon: "passport", color: "#fb7185", purpose: "Entry requirements", functions: ["Visa requirements", "Passport validity", "Health documentation", "TIMATIC integration"] },
        { id: "lounge", name: "Lounge Agent", icon: "star", color: "#fbbf24", purpose: "Premium services", functions: ["Access eligibility", "Capacity", "Amenities", "Booking", "Partner lounge network"] },
        { id: "rebooking", name: "Rebooking Agent", icon: "sync", color: "#38bdf8", purpose: "Schedule changes", functions: ["Voluntary changes", "Fare differences", "Same-day standby", "Flight flexibility"] },
        { id: "refund", name: "Refund Agent", icon: "dollar", color: "#4ade80", purpose: "Money-back processing", functions: ["Refund eligibility", "Calculation", "Processing status", "Voucher conversion"] },
        { id: "group", name: "Group Booking Agent", icon: "pilot", color: "#a78bfa", purpose: "10+ passengers", functions: ["Group quotes", "Deposit management", "Name changes", "Rooming lists"] }
      ]
    },
    {
      category: "Internal Operations",
      description: "Agents supporting internal airline operations and staff",
      color: "#ec4899",
      agents: [
        { id: "network", name: "Network Planning Agent", icon: "globe", color: "#f472b6", purpose: "Route optimization", functions: ["Demand forecasting", "Slot management", "Schedule optimization", "Codeshare coordination"] },
        { id: "safety", name: "Safety & Compliance Agent", icon: "shield", color: "#fb923c", purpose: "Regulatory adherence", functions: ["Incident reporting", "Audit preparation", "Regulatory updates", "Safety bulletins"] },
        { id: "training", name: "Training Agent", icon: "robot", color: "#60a5fa", purpose: "Staff development", functions: ["Course scheduling", "Certification tracking", "Recency requirements", "E-learning"] },
        { id: "hr", name: "HR Agent", icon: "pilot", color: "#c084fc", purpose: "Employee services", functions: ["Leave requests", "Benefits queries", "Policy questions", "Onboarding"] },
        { id: "procurement", name: "Procurement Agent", icon: "box", color: "#2dd4bf", purpose: "Vendor management", functions: ["Purchase orders", "Contract queries", "Supplier performance", "Invoice matching"] }
      ]
    }
  ];

  const channels = [
    { icon: "mic", name: "Voice IVR", tech: "ElevenLabs + Twilio", latency: "<300ms", color: "#22d3ee" },
    { icon: "mobile", name: "Mobile SDK", tech: "React Native", latency: "<100ms", color: "#a78bfa" },
    { icon: "globe", name: "Web Widget", tech: "React Embed", latency: "<50ms", color: "#34d399" },
    { icon: "chat", name: "WhatsApp", tech: "Cloud API", latency: "<500ms", color: "#22c55e" },
    { icon: "desktop", name: "Agent Desktop", tech: "Electron/Web", latency: "<50ms", color: "#60a5fa" },
    { icon: "kiosk", name: "Kiosk", tech: "CUTE Platform", latency: "<200ms", color: "#fbbf24" }
  ];

  const renderOverview = () => (
    <div style={styles.mainGrid}>
      <div>
        {/* Layer 1: Channels */}
        <div style={{
          ...styles.layerBox,
          background: 'linear-gradient(to right, rgba(8, 145, 178, 0.2), rgba(6, 182, 212, 0.1))',
          borderColor: 'rgba(6, 182, 212, 0.5)'
        }}>
          <div style={{...styles.layerLabel, color: '#22d3ee'}}>LAYER 1</div>
          <div style={{...styles.layerTitle, color: '#67e8f9'}}>Omnichannel Engagement Layer</div>
          <div style={{...styles.flexRow, marginBottom: '12px'}}>
            <span style={{fontSize: '12px', color: '#94a3b8'}}>WebSocket / REST / gRPC</span>
          </div>
          <div style={{...styles.grid, gridTemplateColumns: 'repeat(6, 1fr)'}}>
            {channels.map((ch, i) => (
              <div key={i} className="arch-card" style={styles.card}>
                <div style={{...styles.cardIcon, display: 'flex', justifyContent: 'center'}}><Icon name={ch.icon} size={28} color={ch.color} /></div>
                <div style={styles.cardTitle}>{ch.name}</div>
                <div style={{...styles.cardSubtitle, color: '#22d3ee'}}>{ch.tech}</div>
                <div style={{...styles.cardSubtitle, color: '#64748b'}}>{ch.latency}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Connector */}
        <div style={styles.connector}>
          <div style={styles.connectorInner}>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #22d3ee, #3b82f6)'}}></div>
            <div style={styles.connectorLabel}>Unified Message Bus (Kafka/Redis)</div>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #3b82f6, #6366f1)'}}></div>
          </div>
        </div>

        {/* Layer 2: Orchestration */}
        <div style={{
          ...styles.layerBox,
          background: 'linear-gradient(to right, rgba(37, 99, 235, 0.2), rgba(99, 102, 241, 0.1))',
          borderColor: 'rgba(59, 130, 246, 0.5)'
        }}>
          <div style={{...styles.layerLabel, color: '#60a5fa'}}>LAYER 2</div>
          <div style={{...styles.layerTitle, color: '#93c5fd'}}>AI Gateway & Orchestration</div>
          <div style={{...styles.grid, gridTemplateColumns: 'repeat(3, 1fr)'}}>
            <div className="arch-card" style={styles.card}>
              <div style={{...styles.cardTitle, color: '#93c5fd', marginBottom: '8px'}}>API Gateway</div>
              {['Authentication (OAuth2/JWT)', 'Rate Limiting', 'Request Validation', 'Load Balancing'].map((item, i) => (
                <div key={i} style={{fontSize: '11px', color: '#94a3b8', padding: '2px 0'}}>{item}</div>
              ))}
            </div>
            <div className="arch-card" style={styles.card}>
              <div style={{...styles.cardTitle, color: '#93c5fd', marginBottom: '8px'}}>Agent Orchestrator</div>
              {['Intent Classifier', 'Context Manager', 'Agent Router', 'Fallback Handler'].map((item, i) => (
                <div key={i} style={{fontSize: '11px', color: '#94a3b8', padding: '2px 0'}}>{item}</div>
              ))}
            </div>
            <div className="arch-card" style={styles.card}>
              <div style={{...styles.cardTitle, color: '#93c5fd', marginBottom: '8px'}}>LLM Runtime</div>
              {['Primary: Claude Haiku 4.5', 'Complex: Claude Sonnet', 'Fallback: GPT-4o', 'Prompt Cache: Redis'].map((item, i) => (
                <div key={i} style={{fontSize: '11px', color: '#94a3b8', padding: '2px 0'}}>{item}</div>
              ))}
            </div>
          </div>
        </div>

        {/* Connector */}
        <div style={styles.connector}>
          <div style={styles.connectorInner}>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #6366f1, #10b981)'}}></div>
            <div style={styles.connectorLabel}>Agent Invocation</div>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #10b981, #10b981)'}}></div>
          </div>
        </div>

        {/* Layer 3: Agents */}
        <div style={{
          ...styles.layerBox,
          background: 'linear-gradient(to right, rgba(16, 185, 129, 0.2), rgba(20, 184, 166, 0.1))',
          borderColor: 'rgba(16, 185, 129, 0.5)'
        }}>
          <div style={{...styles.layerLabel, color: '#34d399'}}>LAYER 3</div>
          <div style={{...styles.layerTitle, color: '#6ee7b7'}}>Specialized AI Agents</div>
          <div style={{...styles.grid, gridTemplateColumns: 'repeat(6, 1fr)'}}>
            {Object.entries(agents).map(([key, agent]) => (
              <div
                key={key}
                className="arch-card"
                onClick={() => { setSelectedAgent(key); setActiveTab('agents'); }}
                style={{
                  ...styles.card,
                  cursor: 'pointer',
                  border: selectedAgent === key ? '2px solid #34d399' : '2px solid transparent'
                }}
              >
                <div style={{...styles.cardIcon, display: 'flex', justifyContent: 'center'}}><Icon name={agent.icon} size={28} color={agent.iconColor} /></div>
                <div style={styles.cardTitle}>{agent.name}</div>
                <div style={{...styles.cardSubtitle, color: '#34d399'}}>{agent.mcpTools.length} tools</div>
              </div>
            ))}
          </div>
        </div>

        {/* Connector */}
        <div style={styles.connector}>
          <div style={styles.connectorInner}>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #10b981, #f59e0b)'}}></div>
            <div style={styles.connectorLabel}>MCP Protocol (JSON-RPC)</div>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #f59e0b, #f59e0b)'}}></div>
          </div>
        </div>

        {/* Layer 4: MCP Tools */}
        <div style={{
          ...styles.layerBox,
          background: 'linear-gradient(to right, rgba(245, 158, 11, 0.2), rgba(249, 115, 22, 0.1))',
          borderColor: 'rgba(245, 158, 11, 0.5)'
        }}>
          <div style={{...styles.layerLabel, color: '#fbbf24'}}>LAYER 4</div>
          <div style={{...styles.layerTitle, color: '#fcd34d'}}>MCP Tools Layer (Configurable)</div>
          <div style={{...styles.grid, gridTemplateColumns: 'repeat(4, 1fr)'}}>
            {[
              { name: "PSS Connector", tools: 12, protocol: "SOAP/NDC" },
              { name: "DCS Connector", tools: 8, protocol: "IATA Type-B" },
              { name: "Loyalty Connector", tools: 9, protocol: "REST" },
              { name: "Revenue Connector", tools: 7, protocol: "REST/SOAP" },
              { name: "Ops Connector", tools: 10, protocol: "ACARS/REST" },
              { name: "CRM Connector", tools: 8, protocol: "REST" },
              { name: "Payment Connector", tools: 6, protocol: "REST" },
              { name: "Notification Hub", tools: 5, protocol: "REST" }
            ].map((conn, i) => (
              <div key={i} className="arch-card" style={styles.card}>
                <div style={{...styles.cardTitle, color: '#fcd34d'}}>{conn.name}</div>
                <div style={{...styles.flexRow, marginTop: '8px'}}>
                  <span style={{fontSize: '11px', color: '#fbbf24'}}>{conn.tools} tools</span>
                  <span style={{fontSize: '11px', color: '#64748b'}}>{conn.protocol}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Connector */}
        <div style={styles.connector}>
          <div style={styles.connectorInner}>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #f59e0b, #f43f5e)'}}></div>
            <div style={styles.connectorLabel}>System APIs (SOAP / REST / NDC)</div>
            <div style={{...styles.connectorLine, background: 'linear-gradient(to bottom, #f43f5e, #f43f5e)'}}></div>
          </div>
        </div>

        {/* Layer 5: Core Systems */}
        <div style={{
          ...styles.layerBox,
          background: 'linear-gradient(to right, rgba(244, 63, 94, 0.2), rgba(236, 72, 153, 0.1))',
          borderColor: 'rgba(244, 63, 94, 0.5)'
        }}>
          <div style={{...styles.layerLabel, color: '#fb7185'}}>LAYER 5</div>
          <div style={{...styles.layerTitle, color: '#fda4af'}}>Airline Core Systems (Existing)</div>
          <div style={{...styles.grid, gridTemplateColumns: 'repeat(6, 1fr)'}}>
            {[
              { icon: "ticket", name: "PSS", desc: "Amadeus / Sabre", color: "#fb7185" },
              { icon: "passport", name: "DCS", desc: "SITA / Amadeus", color: "#f472b6" },
              { icon: "trophy", name: "FFP", desc: "Comarch / Custom", color: "#fbbf24" },
              { icon: "chart", name: "RMS", desc: "PROS / Kambr", color: "#34d399" },
              { icon: "pilot", name: "Crew", desc: "Jeppesen / IBS", color: "#60a5fa" },
              { icon: "box", name: "Cargo", desc: "iCargo / CHAMP", color: "#a78bfa" }
            ].map((sys, i) => (
              <div key={i} className="arch-card" style={styles.card}>
                <div style={{...styles.cardIcon, display: 'flex', justifyContent: 'center'}}><Icon name={sys.icon} size={28} color={sys.color} /></div>
                <div style={{...styles.cardTitle, color: '#fda4af'}}>{sys.name}</div>
                <div style={{...styles.cardSubtitle, color: '#64748b'}}>{sys.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div style={styles.sidebar}>
        <div style={{...styles.sidebarBox, borderColor: 'rgba(139, 92, 246, 0.5)'}}>
          <div style={{...styles.sidebarTitle, color: '#a78bfa', display: 'flex', alignItems: 'center', gap: '8px'}}><Icon name="shield" size={16} color="#a78bfa" /> Security & Compliance</div>
          {[
            { title: 'Identity & Access', desc: 'OAuth2.0, SAML, JWT, RBAC' },
            { title: 'Data Protection', desc: 'TLS 1.3, AES-256, PII tokenization' },
            { title: 'Compliance', desc: 'PCI-DSS, GDPR, SOC 2 Type II' }
          ].map((item, i) => (
            <div key={i} style={styles.sidebarItem}>
              <div style={{...styles.sidebarItemTitle, color: '#c4b5fd'}}>{item.title}</div>
              <div style={styles.sidebarItemDesc}>{item.desc}</div>
            </div>
          ))}
        </div>

        <div style={{...styles.sidebarBox, borderColor: 'rgba(20, 184, 166, 0.5)'}}>
          <div style={{...styles.sidebarTitle, color: '#5eead4', display: 'flex', alignItems: 'center', gap: '8px'}}><Icon name="analytics" size={16} color="#5eead4" /> Observability</div>
          {[
            { title: 'Metrics', desc: 'Prometheus + Grafana' },
            { title: 'Tracing', desc: 'OpenTelemetry + Jaeger' },
            { title: 'Logging', desc: 'ELK Stack / Loki' }
          ].map((item, i) => (
            <div key={i} style={styles.sidebarItem}>
              <div style={{...styles.sidebarItemTitle, color: '#99f6e4'}}>{item.title}</div>
              <div style={styles.sidebarItemDesc}>{item.desc}</div>
            </div>
          ))}
        </div>

        <div style={{...styles.sidebarBox, borderColor: 'rgba(56, 189, 248, 0.5)'}}>
          <div style={{...styles.sidebarTitle, color: '#7dd3fc', display: 'flex', alignItems: 'center', gap: '8px'}}><Icon name="database" size={16} color="#7dd3fc" /> Data Layer</div>
          {[
            { title: 'Session Store', desc: 'Redis Cluster, 24h TTL' },
            { title: 'Vector Store', desc: 'Pinecone / Weaviate' },
            { title: 'Event Stream', desc: 'Kafka' }
          ].map((item, i) => (
            <div key={i} style={styles.sidebarItem}>
              <div style={{...styles.sidebarItemTitle, color: '#bae6fd'}}>{item.title}</div>
              <div style={styles.sidebarItemDesc}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderAgents = () => (
    <div>
      {/* Header Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '16px',
        marginBottom: '32px'
      }}>
        {allAgentsCategories.map((cat, i) => (
          <div key={i} className="arch-card" style={{
            background: 'rgba(30, 41, 59, 0.5)',
            border: `1px solid ${cat.color}30`,
            borderRadius: '12px',
            padding: '16px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', fontWeight: '700', color: cat.color }}>{cat.agents.length}</div>
            <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>{cat.category}</div>
          </div>
        ))}
      </div>

      {/* Total Agents Banner */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(139, 92, 246, 0.1))',
        border: '1px solid rgba(6, 182, 212, 0.3)',
        borderRadius: '16px',
        padding: '20px 24px',
        marginBottom: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div>
          <div style={{ fontSize: '24px', fontWeight: '700' }}>
            <span style={{ background: 'linear-gradient(135deg, #06b6d4, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              {allAgentsCategories.reduce((sum, cat) => sum + cat.agents.length, 0)} AI Agents
            </span>
          </div>
          <div style={{ fontSize: '14px', color: '#94a3b8', marginTop: '4px' }}>
            Comprehensive suite covering every aspect of airline operations
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['MCP Protocol', 'Real-time', 'Multi-language'].map((tag, i) => (
            <span key={i} style={{
              padding: '6px 12px',
              background: 'rgba(6, 182, 212, 0.2)',
              border: '1px solid rgba(6, 182, 212, 0.3)',
              borderRadius: '20px',
              fontSize: '12px',
              color: '#22d3ee'
            }}>{tag}</span>
          ))}
        </div>
      </div>

      {/* Categorized Agents */}
      {allAgentsCategories.map((category, catIndex) => (
        <div key={catIndex} style={{ marginBottom: '32px' }}>
          {/* Category Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px',
            paddingBottom: '12px',
            borderBottom: `2px solid ${category.color}30`
          }}>
            <div style={{
              width: '8px',
              height: '32px',
              background: category.color,
              borderRadius: '4px'
            }} />
            <div>
              <h3 style={{ fontSize: '20px', fontWeight: '600', margin: 0, color: category.color }}>
                {category.category}
              </h3>
              <p style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0 0' }}>
                {category.description}
              </p>
            </div>
            <div style={{
              marginLeft: 'auto',
              padding: '4px 12px',
              background: `${category.color}20`,
              borderRadius: '12px',
              fontSize: '13px',
              color: category.color,
              fontWeight: '600'
            }}>
              {category.agents.length} agents
            </div>
          </div>

          {/* Agents Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '16px'
          }}>
            {category.agents.map((agent, agentIndex) => (
              <div
                key={agentIndex}
                className="arch-card"
                style={{
                  background: 'rgba(30, 41, 59, 0.5)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: '16px',
                  padding: '20px',
                  transition: 'all 0.3s ease'
                }}
              >
                {/* Agent Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <div style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: `${agent.color}20`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name={agent.icon} size={24} color={agent.color} />
                  </div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '600', color: 'white' }}>{agent.name}</div>
                    <div style={{ fontSize: '12px', color: '#64748b' }}>{agent.purpose}</div>
                  </div>
                </div>

                {/* Functions */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {agent.functions.slice(0, 4).map((func, funcIndex) => (
                    <span
                      key={funcIndex}
                      style={{
                        padding: '4px 8px',
                        background: 'rgba(51, 65, 85, 0.5)',
                        borderRadius: '6px',
                        fontSize: '11px',
                        color: '#94a3b8'
                      }}
                    >
                      {func}
                    </span>
                  ))}
                  {agent.functions.length > 4 && (
                    <span style={{
                      padding: '4px 8px',
                      background: `${agent.color}20`,
                      borderRadius: '6px',
                      fontSize: '11px',
                      color: agent.color
                    }}>
                      +{agent.functions.length - 4} more
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Core Agent Details Section */}
      <div style={{
        marginTop: '48px',
        paddingTop: '32px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '20px' }}>
          Core Agent Details <span style={{ fontSize: '14px', color: '#64748b', fontWeight: '400' }}>— MCP Tools & Integrations</span>
        </h3>

        <div style={{display: 'grid', gridTemplateColumns: '250px 1fr', gap: '16px'}}>
          {/* Agent List */}
          <div>
            <div style={{fontSize: '14px', color: '#94a3b8', marginBottom: '12px'}}>Select an Agent</div>
            {Object.entries(agents).map(([key, agent]) => (
              <div
                key={key}
                onClick={() => setSelectedAgent(key)}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  marginBottom: '8px',
                  background: selectedAgent === key ? 'linear-gradient(to right, rgba(16, 185, 129, 0.4), rgba(20, 184, 166, 0.2))' : 'rgba(30, 41, 59, 0.5)',
                  border: selectedAgent === key ? '2px solid #34d399' : '2px solid #334155'
                }}
              >
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  <Icon name={agent.icon} size={20} color={agent.iconColor} />
                  <span style={{fontWeight: '500'}}>{agent.name}</span>
                </div>
                <div style={{fontSize: '12px', color: '#64748b', marginTop: '4px'}}>{agent.mcpTools.length} MCP tools</div>
              </div>
            ))}
          </div>

          {/* Agent Details */}
          <div style={{
            background: 'rgba(30, 41, 59, 0.5)',
            border: '1px solid #334155',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px'}}>
              <div style={{width: '56px', height: '56px', borderRadius: '12px', background: 'rgba(51, 65, 85, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Icon name={agents[selectedAgent].icon} size={32} color={agents[selectedAgent].iconColor} />
              </div>
              <div>
                <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: 0}}>{agents[selectedAgent].name}</h2>
                <p style={{color: '#94a3b8', margin: '4px 0 0 0'}}>{agents[selectedAgent].purpose}</p>
              </div>
            </div>

            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px'}}>
              {/* Capabilities */}
              <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', fontWeight: '500', color: '#34d399', marginBottom: '12px'}}>Capabilities</div>
                {agents[selectedAgent].capabilities.map((cap, i) => (
                  <div key={i} style={{fontSize: '12px', color: '#cbd5e1', display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px'}}>
                    <span style={{color: '#34d399'}}>•</span>
                    {cap}
                  </div>
                ))}
              </div>

              {/* MCP Tools */}
              <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', fontWeight: '500', color: '#fbbf24', marginBottom: '12px'}}>MCP Tools</div>
                <div style={{maxHeight: '250px', overflowY: 'auto'}}>
                  {agents[selectedAgent].mcpTools.map((tool, i) => (
                    <div key={i} style={{background: 'rgba(30, 41, 59, 0.6)', borderRadius: '4px', padding: '8px', marginBottom: '8px'}}>
                      <div style={{fontFamily: 'monospace', fontSize: '12px', color: '#fcd34d'}}>{tool.name}</div>
                      <div style={{fontSize: '11px', color: '#64748b', marginTop: '4px'}}>
                        <span style={{color: '#94a3b8'}}>params:</span> {tool.params}
                      </div>
                      <div style={{fontSize: '11px', color: '#64748b'}}>
                        <span style={{color: '#94a3b8'}}>returns:</span> {tool.returns}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Integrations & State */}
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px'}}>
              <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', fontWeight: '500', color: '#60a5fa', marginBottom: '12px'}}>System Integrations</div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                  {agents[selectedAgent].integrations.map((int, i) => (
                    <span key={i} style={{...styles.badge, background: 'rgba(37, 99, 235, 0.3)', color: '#93c5fd'}}>{int}</span>
                  ))}
                </div>
              </div>
              <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', fontWeight: '500', color: '#a78bfa', marginBottom: '12px'}}>State Management</div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                  {agents[selectedAgent].stateManagement.map((state, i) => (
                    <span key={i} style={{...styles.badge, background: 'rgba(139, 92, 246, 0.3)', color: '#c4b5fd'}}>{state}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDataFlow = () => (
    <div style={{background: 'rgba(30, 41, 59, 0.5)', border: '1px solid #334155', borderRadius: '12px', padding: '20px'}}>
      <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '20px'}}>End-to-End Request Flow: Voice Booking Example</h3>
      
      <div>
        {[
          { step: 1, actor: "Passenger", action: "Speaks", detail: '"Book a flight from NYC to London next Friday"', color: '#22d3ee' },
          { step: 2, actor: "Voice IVR", action: "Transcribes", detail: "ElevenLabs STT → Text + Audio metadata", color: '#22d3ee' },
          { step: 3, actor: "API Gateway", action: "Authenticates", detail: "Validate session, rate limit check, log request", color: '#60a5fa' },
          { step: 4, actor: "Orchestrator", action: "Classifies", detail: "Intent: FLIGHT_SEARCH, Entities: {origin: JFK, dest: LHR}", color: '#60a5fa' },
          { step: 5, actor: "Orchestrator", action: "Routes", detail: "Select Booking Agent, load passenger context", color: '#60a5fa' },
          { step: 6, actor: "Booking Agent", action: "Plans", detail: "LLM determines: need to call search_availability tool", color: '#34d399' },
          { step: 7, actor: "MCP Layer", action: "Invokes", detail: "PSS Connector → search_availability(JFK, LHR, 2025-01-03)", color: '#fbbf24' },
          { step: 8, actor: "PSS (Amadeus)", action: "Returns", detail: "5 flight options with pricing and availability", color: '#fb7185' },
          { step: 9, actor: "Booking Agent", action: "Formats", detail: "LLM generates natural language response", color: '#34d399' },
          { step: 10, actor: "Voice IVR", action: "Speaks", detail: "ElevenLabs TTS → Audio response to passenger", color: '#22d3ee' }
        ].map((step) => (
          <div key={step.step} style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px'}}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: `${step.color}20`,
              border: `2px solid ${step.color}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: step.color,
              flexShrink: 0
            }}>
              {step.step}
            </div>
            <div style={{
              flex: 1,
              background: 'rgba(51, 65, 85, 0.3)',
              borderRadius: '8px',
              padding: '10px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <div style={{color: step.color, fontWeight: '500', width: '120px'}}>{step.actor}</div>
              <div style={{color: '#94a3b8', width: '100px'}}>{step.action}</div>
              <div style={{color: '#cbd5e1', fontSize: '13px', flex: 1}}>{step.detail}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Latency */}
      <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px', marginTop: '24px'}}>
        <div style={{fontSize: '14px', fontWeight: '500', marginBottom: '12px'}}>Latency Breakdown (Target: &lt;2s for voice)</div>
        <div style={{display: 'flex', gap: '8px'}}>
          {[
            { label: "STT", time: "200ms", pct: 10 },
            { label: "Gateway", time: "20ms", pct: 1 },
            { label: "Classify", time: "50ms", pct: 2.5 },
            { label: "LLM", time: "400ms", pct: 20 },
            { label: "MCP Tool", time: "800ms", pct: 40 },
            { label: "Format", time: "300ms", pct: 15 },
            { label: "TTS", time: "230ms", pct: 11.5 }
          ].map((seg, i) => (
            <div key={i} style={{flex: 1, textAlign: 'center'}}>
              <div style={{
                height: '24px',
                background: 'linear-gradient(to right, #10b981, #14b8a6)',
                borderRadius: '4px',
                opacity: 0.4 + (seg.pct / 100)
              }}></div>
              <div style={{fontSize: '11px', color: '#cbd5e1', marginTop: '4px'}}>{seg.label}</div>
              <div style={{fontSize: '10px', color: '#64748b'}}>{seg.time}</div>
            </div>
          ))}
        </div>
        <div style={{textAlign: 'right', fontSize: '14px', color: '#34d399', marginTop: '8px'}}>Total: ~2000ms (within target)</div>
      </div>
    </div>
  );

  const renderMCP = () => (
    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px'}}>
      {/* Example Tool Definition */}
      <div style={{background: '#0f172a', borderRadius: '8px', padding: '16px'}}>
        <div style={{color: '#fbbf24', marginBottom: '12px'}}>{/* Example: search_availability tool */}{'// Example: search_availability tool'}</div>
        <pre style={{color: '#cbd5e1', fontSize: '12px', fontFamily: 'monospace', margin: 0, whiteSpace: 'pre-wrap'}}>
{`{
  "name": "search_availability",
  "description": "Search for available flights",
  "inputSchema": {
    "type": "object",
    "properties": {
      "origin": {
        "type": "string",
        "description": "IATA airport code",
        "pattern": "^[A-Z]{3}$"
      },
      "destination": {
        "type": "string",
        "description": "IATA airport code"
      },
      "departure_date": {
        "type": "string",
        "format": "date"
      },
      "passengers": {
        "type": "object",
        "properties": {
          "adults": { "type": "integer" },
          "children": { "type": "integer" }
        }
      },
      "cabin_class": {
        "type": "string",
        "enum": ["economy", "business", "first"]
      }
    },
    "required": ["origin", "destination", "departure_date"]
  }
}`}
        </pre>
      </div>

      {/* Configuration */}
      <div>
        <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px', marginBottom: '16px'}}>
          <div style={{fontSize: '14px', fontWeight: '500', color: '#fbbf24', marginBottom: '12px'}}>Airline-Specific Configuration</div>
          {[
            { label: 'PSS Vendor', value: 'Amadeus Altéa | Sabre | Navitaire' },
            { label: 'API Endpoint', value: 'https://api.amadeus.com/v2' },
            { label: 'Auth Method', value: 'OAuth2 Client Credentials' },
            { label: 'Rate Limits', value: '100 req/s, 10k req/hour' }
          ].map((item, i) => (
            <div key={i} style={{...styles.flexRow, marginBottom: '8px', fontSize: '12px'}}>
              <span style={{color: '#94a3b8'}}>{item.label}</span>
              <span style={{color: 'white', fontFamily: 'monospace'}}>{item.value}</span>
            </div>
          ))}
        </div>

        <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px', marginBottom: '16px'}}>
          <div style={{fontSize: '14px', fontWeight: '500', color: '#60a5fa', marginBottom: '12px'}}>Transport Options</div>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px'}}>
            <div style={{background: 'rgba(30, 41, 59, 0.6)', borderRadius: '4px', padding: '8px'}}>
              <div style={{color: '#93c5fd', fontSize: '12px'}}>stdio</div>
              <div style={{color: '#64748b', fontSize: '11px'}}>Local subprocess, lowest latency</div>
            </div>
            <div style={{background: 'rgba(30, 41, 59, 0.6)', borderRadius: '4px', padding: '8px'}}>
              <div style={{color: '#93c5fd', fontSize: '12px'}}>HTTP + SSE</div>
              <div style={{color: '#64748b', fontSize: '11px'}}>Remote servers, streaming</div>
            </div>
          </div>
        </div>

        <div style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px'}}>
          <div style={{fontSize: '14px', fontWeight: '500', color: '#34d399', marginBottom: '12px'}}>Error Handling</div>
          {[
            'Retry with exponential backoff (max 3 attempts)',
            'Circuit breaker after 5 consecutive failures',
            'Fallback to cached data where applicable',
            'Graceful degradation to human handoff'
          ].map((item, i) => (
            <div key={i} style={{fontSize: '12px', color: '#94a3b8', marginBottom: '4px'}}>• {item}</div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderDeployment = () => (
    <div>
      <div style={{background: 'rgba(30, 41, 59, 0.5)', border: '1px solid #334155', borderRadius: '12px', padding: '20px', marginBottom: '16px'}}>
        <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '16px'}}>Kubernetes Deployment</h3>
        <div style={{...styles.grid, gridTemplateColumns: 'repeat(3, 1fr)'}}>
          {[
            { name: "API Gateway", replicas: "3", cpu: "2 vCPU", mem: "4 GB" },
            { name: "Orchestrator", replicas: "5", cpu: "4 vCPU", mem: "8 GB" },
            { name: "Booking Agent", replicas: "10", cpu: "2 vCPU", mem: "4 GB" },
            { name: "Disruption Agent", replicas: "5", cpu: "2 vCPU", mem: "4 GB" },
            { name: "MCP Connectors", replicas: "10", cpu: "2 vCPU", mem: "4 GB" },
            { name: "Support Agent", replicas: "5", cpu: "2 vCPU", mem: "4 GB" }
          ].map((svc, i) => (
            <div key={i} className="arch-card" style={styles.card}>
              <div style={{fontSize: '13px', fontWeight: '500'}}>{svc.name}</div>
              <div style={{fontSize: '11px', color: '#64748b', marginTop: '4px'}}>
                {svc.replicas} pods • {svc.cpu} • {svc.mem}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '16px'}}>
        {[
          { region: "Europe (Frankfurt)", role: "Primary EU", latency: "<50ms EU" },
          { region: "Americas (Virginia)", role: "Primary US", latency: "<50ms NA" },
          { region: "Asia Pacific (Singapore)", role: "Primary APAC", latency: "<50ms SEA" }
        ].map((r, i) => (
          <div key={i} className="arch-card" style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px', transition: 'all 0.3s ease'}}>
            <div style={{fontSize: '14px', fontWeight: '500'}}>{r.region}</div>
            <div style={{fontSize: '12px', color: '#94a3b8', marginTop: '4px'}}>{r.role}</div>
            <div style={{fontSize: '12px', color: '#34d399', marginTop: '8px'}}>{r.latency}</div>
          </div>
        ))}
      </div>

      <div style={{background: 'rgba(30, 41, 59, 0.5)', border: '1px solid #334155', borderRadius: '12px', padding: '20px'}}>
        <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '16px'}}>Service Level Objectives</h3>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px'}}>
          {[
            { metric: "Availability", target: "99.95%", current: "99.97%" },
            { metric: "Response Time (P95)", target: "<2s voice", current: "1.8s" },
            { metric: "Booking Success", target: ">98%", current: "98.7%" },
            { metric: "Handoff Rate", target: "<5%", current: "3.2%" }
          ].map((slo, i) => (
            <div key={i} className="arch-card" style={{background: 'rgba(51, 65, 85, 0.3)', borderRadius: '8px', padding: '16px', transition: 'all 0.3s ease'}}>
              <div style={{fontSize: '11px', color: '#94a3b8'}}>{slo.metric}</div>
              <div style={{fontSize: '20px', fontWeight: 'bold', marginTop: '4px'}}>{slo.current}</div>
              <div style={{fontSize: '11px', color: '#64748b', marginTop: '4px'}}>Target: {slo.target}</div>
              <div style={{height: '4px', background: '#10b981', borderRadius: '2px', marginTop: '8px'}}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <style>{globalCSS}</style>
      <div style={styles.maxWidth}>
        {/* Header */}
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', marginBottom: '16px' }}>
            <AeronyxLogoArch size={56} />
            <h1 style={styles.title}>Aeronyx — Enterprise Architecture</h1>
          </div>
          <p style={styles.subtitle}>Multi-Agent AI Ecosystem — 26 Specialized Agents with MCP Integration</p>
        </div>

        {/* Tabs */}
        <div style={styles.tabContainer}>
          {[
            { id: 'overview', label: 'System Overview', icon: 'layers' },
            { id: 'agents', label: 'Agent Details', icon: 'robot' },
            { id: 'dataflow', label: 'Data Flow', icon: 'sync' },
            { id: 'mcp', label: 'MCP Specification', icon: 'tools' },
            { id: 'deployment', label: 'Deployment', icon: 'cloud' }
          ].map(tab => (
            <button
              key={tab.id}
              className={activeTab !== tab.id ? 'arch-tab' : ''}
              onClick={() => setActiveTab(tab.id)}
              style={{
                ...styles.tab,
                ...(activeTab === tab.id ? styles.tabActive : styles.tabInactive),
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <Icon name={tab.icon} size={16} color={activeTab === tab.id ? 'white' : '#94a3b8'} />
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        {activeTab === 'overview' && renderOverview()}
        {activeTab === 'agents' && renderAgents()}
        {activeTab === 'dataflow' && renderDataFlow()}
        {activeTab === 'mcp' && renderMCP()}
        {activeTab === 'deployment' && renderDeployment()}

        {/* Footer */}
        <div style={{
          textAlign: 'center',
          marginTop: '48px',
          paddingTop: '32px',
          borderTop: '1px solid rgba(255, 255, 255, 0.05)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '12px' }}>
            <AeronyxLogoArch size={32} />
            <span style={{ fontSize: '18px', fontWeight: '600' }}>Aero<span style={{ color: '#06b6d4' }}>nyx</span></span>
          </div>
          <div style={{ fontSize: '13px', color: '#64748b' }}>
            Enterprise Architecture v2.0 • Enterprise-grade AI Agents Suite for Airlines
          </div>
          <div style={{ fontSize: '12px', color: '#475569', marginTop: '8px' }}>
            © 2025 Aeronyx. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AeronyxArchitecture;
